import * as React from "react";

// components
import { FormattedMessage } from "react-intl";
import CollectionItem from "./collectionItem";
import Icon from "common/icons";
// styles

const styles = require("./collections.scss");

interface IProps {
  collections: ReadonlyArray<Vingle.Collection.ICollection>;
  isMine: boolean;
  redirectToCollectionShow: (collection: Vingle.Id) => void;
}

const MyCollection = ({
  collections,
  isMine,
  redirectToCollectionShow,
}: IProps) => {
  const collectionItems = collections.map(
    (collection: Vingle.Collection.ICollection) => {
      if (collection) {
        return (
          <CollectionItem
            key={collection.id}
            collection={collection}
            mine={isMine}
            redirectToCollectionShow={redirectToCollectionShow}
          />
        );
      }
      return null;
    },
  );

  const empty = (
    <div className={styles.emptyWrapper}>
      <Icon icon="EMPTY_CARD" />
      <span className={styles.message}>
        <FormattedMessage id="profile.error_empty_my_collection" />
      </span>
    </div>
  );

  return (
    <div className={styles.itemWrapper}>
      {collectionItems.length > 0 ? collectionItems : empty}
    </div>
  );
};

export default MyCollection;
